var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tabs',{attrs:{"parent":"ip_addressing"}},[_c('tab',{attrs:{"id":"list","name":_vm.translate('ip_profile.ip-address'),"href":_vm.url+'list'}},[_c('List')],1),_c('tab',{attrs:{"id":"history","name":_vm.translate('addresses.history'),"href":_vm.url+'history'}},[_c('History')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }